export { default as ValueProposition } from './ValueProposition';
